import { ProgressFilter } from '@/const/ProgressFilter'
import { LearningProgress } from '@/const/LearningProgress'
import { StudyCategoryCurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 学習教材用単元情報リストのフィルター処理
 */
export default class CurriculumUnitFilters {
  /**
   * 学習進捗でフィルタリング
   *
   * @param list 学習教材用単元情報のリスト
   * @param progressFilterCode 選択中の学習進捗フィルタのコード
   * @returns StudyCategoryCurriculumUnit[] フィルタリングされた単元教材用単元情報のリスト
   */
  public static byProgressFilter(
    list: StudyCategoryCurriculumUnit[],
    progressFilterCode: string
  ): StudyCategoryCurriculumUnit[] {
    const filterList = list.filter((studyCategoryCurriculumUnit) => {
      const code = studyCategoryCurriculumUnit.learningProgress.code
      switch (progressFilterCode) {
        // 全て
        case ProgressFilter.ALL.code:
          return true
        // 未学習
        case ProgressFilter.NOT_YET.code:
          return code === LearningProgress.NONE.code
        // 進行中
        case ProgressFilter.LEARNING.code:
          return (
            code === LearningProgress.EXAMPLE.code ||
            code === LearningProgress.LEVEL_A.code ||
            code === LearningProgress.LEVEL_B.code ||
            code === LearningProgress.LEVEL_C.code
          )
        // 学習完了
        case ProgressFilter.COMPLETE.code:
          return code === LearningProgress.COMPLETE.code
      }
    })
    return filterList
  }
}
